import { atom } from 'jotai';

type ExitPromptType = 'none' | 'simple' | 'password';

const exitSpacePromptAtom = atom<ExitPromptType>('none');

export default exitSpacePromptAtom;
